// extracted by mini-css-extract-plugin
export default {"cls1":"ResearcherList-cls1__z9","cls2":"ResearcherList-cls2_N5b ResearcherList-cls1__z9"};